import {
  Step,
  StepConnector,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
  makeStyles,
  withStyles,
} from "@material-ui/core";
import { CheckCircle, DoneAll, GroupAdd, LineStyle, PlaylistAdd, Settings, VideoLabel } from "@material-ui/icons";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { SignatureIcon } from "../../../components/Icons";
import { Get } from "../../../actions";
export const MinutesProgressBar = ({ meetingInfo, getTranslation }) => {
  const useColorlibStepIconStyles = makeStyles({
    root: {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#fff",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
    active: {
      backgroundColor:
        "#233044",
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
    },
    completed: {
      backgroundColor:
        "#233044",
    },
  });

  const [activeStep, setActiveStep] = useState(0);
  const [memberInvolved,setMemberInvolved]=useState({})

  useEffect(()=>{
    setActiveStep(meetingInfo?.minuteReportStatus-1);
  },[meetingInfo?.minuteReportStatus])


  const steps = getSteps();

  function getSteps() {
    return ["Generate", "Internal Review", "Fund Manger Review","Signing","Completed"];
  }
  const ColorlibConnector = withStyles({
    alternativeLabel: {
      top: 22,
    },
    active: {
      "& $line": {
        backgroundImage:
          "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
      },
    },
    completed: {
      "& $line": {
        backgroundImage:
          "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
      },
    },
    line: {
      height: 3,
      border: 0,
      backgroundColor: "#eaeaf0",
      borderRadius: 1,
    },
  })(StepConnector);
  function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;
    const icons = {
      1: <LineStyle />,
      2: <DoneAll />,
      3: <DoneAll />,
      4: <SignatureIcon />,
      5: <CheckCircle />,
    };

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed,
        })}
      >
        {icons[String(props.icon)]}
      </div>
    );
  }

const getMemberInvolved = () => {
  if (meetingInfo?.id) {
    Get(
      {
        meetingId: meetingInfo.id,
      },
      "Meeting/GetInvolvedPersonsForReviewInMinutes",
      null,
      (resp) => {
        console.log("kjashlkashdjkasjda",resp.data)
        setMemberInvolved(resp.data);
      },
      (error) => {
        console.log("kjashlkashdjkasjda error",error)

      }
    );
  }
};

useEffect(()=>{
  getMemberInvolved()
},[meetingInfo])

  return (
    <Stepper
      alternativeLabel
      activeStep={activeStep}
      connector={<ColorlibConnector />}
    >
      {steps.map((label,index) => (
        <Step key={label}>
          <StepLabel StepIconComponent={ColorlibStepIcon} >
            <Typography> {label}</Typography>
            <Typography>{
              index==0?"By "+memberInvolved.minutesMember:
              index==1?"By "+memberInvolved.internalReview:
              index==2?"By "+memberInvolved.fundManager:""
              }</Typography>
            </StepLabel>
          
        </Step>
      ))}
    </Stepper>
  );

};
